import { FC } from "react";
import { Controller } from "react-hook-form";
import * as React from "react";
import { TextField, ITextFieldProps } from "@fluentui/react/lib/TextField";
import { ReactHookFormControlProps } from "../CustomTemplates/CustomForm/Models/ReactHookFormControlProps";

export const RHFTextBoxAreaControl: FC<ReactHookFormControlProps & ITextFieldProps> = (props) => {
    return (
        <Controller
            name={props.id}
            control={props.control}
            rules={props.rules}
            defaultValue={props.defaultValue}
            render={({
                field: { onChange, onBlur, name: fieldName, value },
                fieldState: { error }
            }) => (
                <TextField
                    id={props.id}
                    name={fieldName}
                    label={props.label}
                    onRenderLabel={props.onRenderLabel}
                    title={props.title}
                    errorMessage={error && error.message}
                    required={props.required}
                    value={value}
                    onChange={(event, newValue) => {
                        props.setValue(props.id, newValue)
                        onChange(newValue)
                    }}
                    onBlur={onBlur}
                    resizable={false}
                    defaultValue={undefined}
                    multiline={true}
                    rows={props.rows !== undefined ? props.rows : 6}
                    tabIndex={props.tabIndex}
                    maxLength={props.maxLength}
                    disabled={props.disabled !== undefined ? props.disabled : false}
                />
            )}
        />
    );
};